import script from "./bet-info.vue?vue&type=script&setup=true&lang=js"
export * from "./bet-info.vue?vue&type=script&setup=true&lang=js"

import "./bet-info.vue?vue&type=style&index=0&id=5da7f6f3&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da7f6f3"]])

export default __exports__